import { TeaserDataApiResponse } from "@app/types/ServerCustomContext";
import { mapTeaserDataToLatestProps } from "@app/utils/mapTeaserDataToProps";
import { configError, configLatestStory, configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  LatestArticle,
  NaturalCarousel,
  Typography,
  useCustomClassContext,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import useSWR from "swr";

import styles from "./ErrorLayout.module.css";

const { Heading } = Typography;

const ErrorRelatedArticles = () => {
  const { data } = useSWR<TeaserDataApiResponse>(
    `/_plat/api/teaser/${configError.teaser?.api || "latest"}?size=${configError.teaser?.limit || 3}`,
  );
  const customClass = useCustomClassContext();

  const items =
    !!data?.results?.length &&
    data.results
      .map((teaser) => mapTeaserDataToLatestProps(teaser))
      .map((data, index) => (
        <LatestArticle
          key={index}
          {...data}
          mode={
            (Array.isArray(configLatestStory.errorLayoutMode)
              ? configLatestStory.errorLayoutMode[index]
              : configLatestStory.errorLayoutMode) || "portrait"
          }
          portraitImageWidth={configLatestStory.portraitImageWidth}
          landscapeImageWidth={configLatestStory.landscapeImageWidth}
          placeholders={placeholders}
          displayPublishDate={configTeaser.publishDate}
          dateAfter={configTeaser.dateAfter}
        />
      ));

  return (
    !!data?.results?.length && (
      <div
        className={cx(
          styles.bodyContainer,
          styles.gutterHorizontal,
          styles.relatedContentBlock,
        )}
      >
        <Heading.SubHeading3>
          <div className={cx(customClass?.relatedItem?.verticalLine)}>
            {configError.relatedTitle ||
              "Perhaps you might be interested in these."}
          </div>
        </Heading.SubHeading3>
        {configError.relatedAltTitle && (
          <Heading.SubHeading3Alt>
            <div className={cx(customClass?.relatedItem?.verticalLine)}>
              {configError.relatedAltTitle}
            </div>
          </Heading.SubHeading3Alt>
        )}
        {configError.scrollable ? (
          <div className={styles.scrollableContent}>
            <NaturalCarousel
              isLooping={false}
              showArrowsOnMobile
              arrowSize={configError.scrollable.arrowSize ?? 40}
            >
              {items}
            </NaturalCarousel>
          </div>
        ) : (
          <div
            className={cx(styles.content, customClass?.relatedItem?.firstItem)}
          >
            {items}
          </div>
        )}
      </div>
    )
  );
};

export default ErrorRelatedArticles;
